import { memo } from 'react';
import { useWorkshopJobs } from '../../functions/useWorkshopJobs';
import { JobTable } from '../job-table';

/** The 施工 board: the construction jobs still open. */
export const JobBoard = memo(({ now }: { now: Date }) => {
  const jobs = useWorkshopJobs();
  return <JobTable jobs={jobs} now={now} />;
});
